<template>
  <zm-dialog
    :visible="visible"
    class="opc-coupon-terms-condition"
    width="520px"
    :title="$t('billing.coupon.terms_and_conditions')"
    @close="handleCancel"
  >
    <zm-alert v-if="warningTip" class="alert-warning-banner" :closable="false" style="margin-bottom: 16px;">
      <div slot="title" class="alert-warning-banner__title">
        <i alt="alert icon" :style="{backgroundImage: `url(${alertIcon})`}"></i>
        <p>{{ warningTip }}</p>
      </div>
    </zm-alert>
    <div v-html="termsCondition" class="opc-coupon-terms-condition__body"></div>
    <div slot="footer">
      <zm-button type="primary" @click="onAccept">
        {{ $t('billing.common.accept') }}
      </zm-button>
      <zm-button @click="onReject">{{ $t('billing.common.reject') }}</zm-button>
    </div>
  </zm-dialog>
</template>
<script>
import _ from 'lodash';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { mapGetters } from 'vuex';
import alertIcon from '@/assets/Alert.svg';
import { ConsumptionCategoryList } from '@/common/constants';
import { subscriptionLevelActionEnum } from '@/views/config/coupon/helper/constant';

export default {
  mixins: [ConfirmComponent],
  data() {
    return {
      alertIcon,
      termsCondition: "",
    };
  },
  computed: {
    ...mapGetters(['boughtPlans', 'couponState']),
    hasConsumptionPlan() {
      return _.some(this.boughtPlans, p => _.includes(ConsumptionCategoryList, p.plan_code));
    },
    warningTip() {
      // one-time zs/ze ppa consumption plan
      if (this.hasConsumptionPlan) {
        const isReplaceSubscription = this.couponState?.subscriptionLevelAction === subscriptionLevelActionEnum.replaceSubscription;

        return isReplaceSubscription ? this.$t('billing.events.ppa_terms_condition_imme') : null;
      }

      return null;
    },
  },
  methods: {
    onAccept() {
      this.handleSure();
    },
    onReject() {
      this.handleCancel();
    },
  },
};
</script>
<style lang="scss">
.zm-alert {
  &.alert-warning-banner {
    background-color: #FEF7D9 !important;
    padding: 12px 8px;
    margin-top: -12px;

    &__title {
      display: flex;

      i {
        $icon-size: 24px;
        display: block;
        flex: $icon-size 0 0;
        height: $icon-size;
        background-repeat: no-repeat;
        background-size: cover;
        align-self: baseline;
        margin-right: 12px;
      }

      p {
        margin-bottom: 0;
        color: #815A30;
        font-size: 14px;
        font-weight: 450;
      }
    }

    .zm-alert__content .zm-button--icon:hover {
      background-color: transparent;
    }
  }
}

.opc-coupon-terms-condition {
  &__body {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 5px;
    color: #232333;
    font-size: 14px;
    line-height: 21px;
    font-family: 'Almaden Sans','Helvetica','Arial'!important;

    ul {
      margin: 8px 0px;
      padding-left: 25px;
      list-style: unset;

      li {
        padding: 2px 0px;
      }
    }

    &::-webkit-scrollbar {
      width: 7px;
      cursor: pointer;
      background: #f8f8f8;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      opacity: .4;
      border-radius: 7px;
    }

    &::-webkit-scrollbar-track {
      background-color: #f8f8f8;
    }
  }
}
</style>
